import window from 'window-or-global';

const doInsertDefaultTable = () => {
	window.tinymce.execCommand('confInsertTable', false, { cols: 3, rows: 3 });
};

const doPublish = () => {
	document.querySelector('#rte-button-publish').click();
};

const doPreview = () => {
	document.querySelector('#rte-button-preview').click();
};

const buildFormatFunction = (ed, format) => {
	return function () {
		ed.execCommand('FormatBlock', false, format);
	};
};

export { doInsertDefaultTable, doPublish, doPreview, buildFormatFunction };
